const CustomizePackagingMaterials = () => {
    return (
      <div>
    
    <div className="flex flex-col justify-center  gap-1 max-w-[50rem] mx-auto pl-[2rem] pr-[2rem]">
      <h1 className="text-[20px] font-bold">Customised Packing</h1>
     <p>
      Safe packing for a move is a stressful, time consuming and a physically draining process. 
      This is where our standardised services provide convenience, efficiency, and safety for your 
      possessions by customising how each on-the-move item should be packed.
      </p>
      <p>
      Our packing solutions make sure that all regulatory guidelines for sensitive shipments and 
      packing methods are followed, with each item properly labelled with the address and care instructions. 
      This service is especially useful for online retail businesses, furniture showrooms, SMEs relocating 
      their premises, students, soldiers, importers and exporters.
      </p>

     
    </div>
  </div>
    );
  };
  
export default CustomizePackagingMaterials;
  